import React from 'react';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Mark from './Mark';
import Wordmark from './Wordmark';
import Reveal from './Reveal';
import { LANDING_FONT, LC, MAXW, PAD_X, r } from './landingTokens';

const COLS = [
  {
    h: 'Product',
    // Mirrors the header IA: Library's dropdown entries (Supplements,
    // Conditions) listed explicitly, Market → /products.
    links: [
      { label: 'How it works', anchor: '#how' },
      { label: 'Supplements', to: '/supplements' },
      { label: 'Conditions', to: '/conditions' },
      { label: 'Market', to: '/products' },
    ],
  },
  {
    h: 'Company',
    links: [
      { label: 'Our story', to: '/about-us' },
      { label: 'Insights', to: '/blog' },
      { label: 'Contact', to: '/contact-us' },
    ],
  },
  {
    h: 'Legal',
    links: [
      { label: 'Privacy', to: '/privacy-policy' },
      { label: 'Terms', to: '/terms-of-use' },
    ],
  },
];

export default function LandingFooter() {
  const navigate = useNavigate();
  const go = (l) => {
    if (l.to) navigate(l.to);
    else if (l.anchor) {
      const el = document.querySelector(l.anchor);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const linkSx = { display: 'block', textAlign: 'left', background: 'none', border: 'none', cursor: 'pointer', p: 0, fontFamily: LANDING_FONT, fontSize: r(14), color: LC.navLink, textDecoration: 'none', mb: r(9), '&:hover': { color: 'primary.contrastText' } };

  return (
    <Box component="footer" sx={{ background: LC.evergreen, color: LC.mint, display: 'flex', justifyContent: 'center' }}>
      {/* Gentler trigger than MOTION.trigger: the footer is the last element on
          the page, so it can never rise 38% up the viewport. */}
      <Reveal repeat rootMargin="0px 0px -8% 0px" sx={{ width: '100%', maxWidth: MAXW, px: PAD_X, pt: r(48), pb: r(36) }}>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: r(32), justifyContent: 'space-between', pb: r(26), borderBottom: `${r(1)} solid rgba(255,255,255,.12)` }}>
          <Box sx={{ maxWidth: r(300), display: 'inline-flex', alignItems: 'center', gap: r(10) }}>
            <Mark size={24} variant="onDark" strokeWidth={3.5} />
            <Wordmark size={22} variant="onDark" />
          </Box>
          <Box sx={{ display: 'flex', gap: 'clamp(1.75rem, 5vw, 3rem)', flexWrap: 'wrap' }}>
            {COLS.map((col) => (
              <Box key={col.h}>
                <Box component="h4" sx={{ m: `0 0 ${r(12)}`, fontFamily: LANDING_FONT, fontSize: r(11), fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', color: 'rgba(255,255,255,.45)' }}>{col.h}</Box>
                {col.links.map((l) => (
                  <Box key={l.label} component="button" onClick={() => go(l)} sx={linkSx}>{l.label}</Box>
                ))}
              </Box>
            ))}
          </Box>
        </Box>
        <Box sx={{ pt: r(24), display: 'flex', flexWrap: 'wrap', gap: r(14), justifyContent: 'space-between', alignItems: 'flex-start' }}>
          <Box component="p" sx={{ m: 0, fontFamily: LANDING_FONT, fontSize: r(11.5), color: 'rgba(255,255,255,.5)', lineHeight: 1.6, maxWidth: '62ch' }}>
            <Box component="b" sx={{ color: 'rgba(255,255,255,.75)', fontWeight: 600 }}>Disclaimer:</Box> Information provided by myStack is for informational purposes only and is not intended as medical advice. Always consult a healthcare professional about your health routine. These statements have not been evaluated by the Food and Drug Administration. myStack is not intended to diagnose, treat, cure, or prevent any disease.
          </Box>
          <Box component="span" sx={{ fontFamily: LANDING_FONT, fontSize: r(11.5), color: 'rgba(255,255,255,.4)', whiteSpace: 'nowrap' }}>
            © 2026 <Wordmark size={11.5} variant="onDark" />
          </Box>
        </Box>
      </Reveal>
    </Box>
  );
}
